// extracted by mini-css-extract-plugin
module.exports = {"finance":"application-footer__finance","links":"application-footer__links","logo":"application-footer__logo"};